var e={defaultHeader:"lds-default-header",header:"lds-default-header--header"};export{e as default};
